import React from "react";
import { _ } from "libs";
import { useCookies } from "react-cookie";
import reactToString from "../libs/reactToString";

const MobileAppsPromotion = () => {
	const [cookies, setCookie] = useCookies(["mobile"]);

	const hideMobile = () => {
		setCookie("hideMobileAppsPromotion", true, { maxAge: 60 * 60 * 24 * 7 });
		window.location.reload();
	};

	return (
		<div id="mobileAppsPromotion">
			<header className="header">
				<nav>
					<div className="main justify-between">
						<a href="https://gotcourts.com" className="logo">
							GotCourts
						</a>
						<div
							className="hideMobile link"
							onClick={() => {
								hideMobile();
							}}
						>
							{_("mobilePage.useWebBtn")}
						</div>
					</div>
				</nav>
			</header>
			<main className="mobileMain">
				<div className="mobilePage">
					<h3
						dangerouslySetInnerHTML={{
							__html: _("mobilePage.heading", null, {
								iOSLink: reactToString(
									<a
										href="http://got.link/ios"
										className="link plain"
										target="_blank"
										rel="noopener noreferrer"
									>
										iOS
									</a>
								),
								androidLink: reactToString(
									<a
										href="http://got.link/android"
										className="link plain"
										target="_blank"
										rel="noopener noreferrer"
									>
										Android
									</a>
								),
							}),
						}}
					/>
					<div className="mobileAppsPreview">
						<div className="aspectRatioFill" />
					</div>
					<div className="mobileAppsDownloadButtons">
						<a
							href="https://got.link/ios"
							className="storeButton appStoreButton"
							target="_blank"
							rel="noopener noreferrer"
						/>
						<a
							href="https://got.link/android"
							className="storeButton playStoreButton"
							target="_blank"
							rel="noopener noreferrer"
						/>
					</div>
				</div>
			</main>
		</div>
	);
};

export default MobileAppsPromotion;
